import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Button, CardActionArea, CardActions } from "@mui/material";

import Upload from "components/shared/Upload";
import { useNavigate } from "react-router-dom";

export default function MediaCard({ item }) {
  const navigate = useNavigate();
  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardActionArea onClick={() => console.log("clicked", item)}>
        <Upload
          file={item.image}
          isWeb
          type="slides-images"
          //   onDelete={() => {
          //     console.log("delete");
          //     // setDeleteItemId(item.id);
          //     // handelShowModal();
          //   }}
          width="100%"
          height="100%"
          objectFit="contain"
        />

        <CardContent>
          <Typography
            gutterBottom
            variant="h6"
            component="div"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis !important",
              display: "-webkit-box !important",
              WebkitLineClamp: "1 !important",
              WebkitBoxOrient: "vertical !important",
            }}
          >
            {item?.title ? item.title : "عنوان"}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis !important",
              display: "-webkit-box !important",
              WebkitLineClamp: "1 !important",
              WebkitBoxOrient: "vertical !important",
            }}
          >
            {item?.text ? item.text : "متن ..."}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button
          variant="contained"
          size="small"
          color="primary"
          onClick={() => navigate(`/slides/edit/${item.id}`)}
        >
          ویرایش
        </Button>
      </CardActions>
    </Card>
  );
}
